import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import Home from '@/views/Home'
import Test from '@/views/Test'
import RenewalNotice from '@/views/wechat/RenewalNotice'
import PolicyInfo from '@/views/wechat/PolicyInfo'
import PolicyInfoFile from '@/views/wechat/PolicyInfoFile'
import WechatMarketInfo from '@/views/wechat/WechatMarketInfo'
import Hr from '@/views/wechat/Hr'
import CommNote from '@/views/wechat/CommNote'
import OverseaApply from '@/views/wechat/OverseaApply'
import Dashboard from '@/views/Dashboard'
import AttachmentView from '@/views/AttachmentView'
import PicView from '@/views/PicView'
import PolicyListView from '@/views/PolicyListView'
import WeixinSweepCode from '@/views/WeixinSweepCode'
import PdfUpdInfo from '@/views/PdfUpdInfo'
import Questionnaire from '@/views/Questionnaire'
import Questionnaire2 from '@/views/Questionnaire2'
import loginEnter from '@/views/loginEnter'
import Echars from '@/views/Echars'
import notFond from '@/views/notFond/notfond'
import error from '@/views/notFond/error'
import mobileLogin from '@/views/mobile/mobileLogin'
import mhomePage from '@/views/mobile/homePage'
import mobileMyPolicy from '@/views/mobile/mobMyPolicy'
import policyDetail from '@/views/mobile/policyDetail'
import mobOverseaApp from '@/views/mobile/mobOverseaApp'
import mobHome from '@/views/mobile/mobHome'
import bookingApplication from '@/views/mobile/bookingApplication'
Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {
            path: '/login',
            name: 'Login',
            component: Login,
            hidden: true,
            children:[]
        },
        {
            path: '/loginEnter',
            name: 'loginEnter',
            component: loginEnter,
            hidden: true,
            children:[]
        },
        {
            path: '/',
            name: 'Home',
            component: Home,
            hidden: true,
            children:[{
                path: 'dashboard',
                name: '首頁',
                component: Dashboard,
                hidden: false,
                children:[]
            },{
              path:'/error',
              name:'error',
              component:error,
              hidden:false
            },
                {
                    path:'/notFond',
                    name:'notFond',
                    component:notFond,
                    hidden:true
                },
                {
                    path: '/echars',
                    name: '图表',
                    component: Echars,
                    hidden: true,
                    children:[]
                },]
        },
        {
            path: '/',
            name: 'Test',
            component: Test,
            hidden: true,
            children:[]
        },
        {
            path: '/renewalNotice',
            name: 'RenewalNotice',
            component: RenewalNotice,
            hidden: true,
            children:[]
        },
        {
            path: '/policyInfo',
            name: 'PolicyInfo',
            component: PolicyInfo,
            hidden: true,
            children:[]
        },
        {
            path: '/policyInfoFile',
            name: 'PolicyInfoFile',
            component: PolicyInfoFile,
            hidden: true,
            children:[]
        },
        {
            path: '/wechatMarketInfo',
            name: 'WechatMarketInfo',
            component: WechatMarketInfo,
            hidden: true,
            children:[]
        },
        {
            path: '/hr',
            name: 'Hr',
            component: Hr,
            hidden: true,
            children:[]
        },
        {
            path: '/commNote',
            name: 'CommNote',
            component: CommNote,
            hidden: true,
            children:[]
        },
        {
            path: '/overseaApply',
            name: 'OverseaApply',
            component: OverseaApply,
            hidden: true,
            children:[]
        },
        {
            path: '/attachmentView',
            name: 'AttachmentView',
            component: AttachmentView,
            hidden: true,
            children:[]
        },
        {
            path: '/picView',
            name: 'PicView',
            component: PicView,
            hidden: true,
            children:[]
        },
        {
            path: '/policyListView',
            name: 'PolicyListView',
            component: PolicyListView,
            hidden: true,
            children:[]
        },
        {
            path: '/weixinSweepCode',
            name: 'WeixinSweepCode',
            component: WeixinSweepCode,
            hidden: true,
            children:[]
        },
        {
            path: '/pdfUpdInfo',
            name: 'PdfUpdInfo',
            component: PdfUpdInfo,
            hidden: true,
            children:[]
        },
        {
            path: '/questionnaire',
            name: 'Questionnaire',
            component: Questionnaire,
            hidden: true,
            children:[]
        },
        {
            path: '/questionnaire2',
            name: 'Questionnaire2',
            component: Questionnaire2,
            hidden: true,
            children:[]
        },
        {
            path:'/mobile/mobileLogin',
            name:'mobileLogin',
            component:mobileLogin,
            hidden:true,
            children:[]
        },
        {
          path:'/mobile/homePage',
          name:'mhomePage',
            component:mhomePage,
            hidden:true,
            children:[]
        },
        {
            path:'/mobile',
            name:'mobHome',
            component:mobHome,
            hidden:true,
            children:[{
                path:'/mobile/myPolicy',
                name:'mobileMyPolicy',
                component:mobileMyPolicy,
                hidden:true,
                children:[],
                meta:{ title:'我的保单'}

            },{
              path:'/mobile/bookingApplication',
              name:'bookingApplication',
              component:bookingApplication,
              hidden:true,
               bookingApplication:[],
                meta:{ title:'预约申请'}

            },
                {
                    path:'/mobile/policyDetail',
                    name:'policyDetail',
                    component:policyDetail,
                    hidden:true,
                    children:[],
                    meta:{title:''}

                },
                {
                    path:'/mobile/mobOverseaApp',
                    name:'mobOverseaApp',
                    component:mobOverseaApp,
                    hidden:true,
                    children:[],
                    meta:{title:'预约申请'}

                },]

        },
        {
            path: "*",
            redirect: "/notFond",
            hidden: true
        },

    ]
})

export default  router;




// WEBPACK FOOTER //
// ./src/router/router.js